$ = jQuery;
$(document).ready(function(e) {
    var skr;

    //run intial function
    init();

    /*********************************************************** CLICK CAPTURE */

    $("body").on("click", "#agegate #verify", function () {
        var verify = sessionStorage.getItem('wp_verify');

        $("#preloader").addClass("in");

        if(!verify) {

            sessionStorage.setItem('wp_verify', true);

        }

        window.scroll(0, 0);

        $("#agegate").addClass('hide');


        return false;

    });


    //navigation icon click
    $("body").on("click", ".respMenu", function(){
        var page = $("#page");

        if(page.hasClass("menu")){

            page.removeClass("menu");

        }
        else{

            page.addClass("menu");

        }

        return false;

    });

    $("body").on("click", "header li.dropdown a.toggle, #navigation li.dropdown a.toggle", function(){

        $(this).closest(".dropdown").toggleClass("open");

        return false;

    });


    $("body").on("click", ".beer_nav_action", function () {

        $("#page").addClass('beer_nav_in');

        return false;

    });

    $("body").on("click", ".close_beer_nav", function () {

        $("#page").removeClass('beer_nav_in');

        return false;

    });

    $("body").on("click", "header .cart_header .open_login span.name", function () {

        $(this).closest('.cart_header').toggleClass('open');

        return false;

    });

    $("body").on("submit", "#customer_login", function (){

        $.ajax({
            type: 'POST',
            url: '/account/login',
            data: $('#customer_login').serializeArray(),
            dataType: 'json',
            success: function(data) {

                console.log(data);


            },
            error: function(data) {

                console.log(data);

            }
        });

        return false;

    });

    $('body').on('click', '#cart_popup .quantity_button.plus, #cart_popup .quantity_button.minus, .cart_page .quantity_button.plus, .cart_page .quantity_button.minus', function(e) {
        var parent = $(this).closest('tr');
        const isNegative = $(e.target).closest('.minus').is('.minus');
        const input = $(e.target).closest('.quantity_selector').find('input');
        if (input.is('input')) {
            input[0][isNegative ? 'stepDown' : 'stepUp']()
        }

        var currentVal = parseInt(input.val(), 10);
        var currentVariant =  $(e.target).closest('.quantity_selector').data("id");

        var data = { updates: {} };
        data.updates[currentVariant] = currentVal;

        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: data,
            dataType: 'json',
            success: function(data) {
                var total_price = data.total_price;

                console.log(data);


                refreshCart();

                total_price = total_price / 100;

                $('#cart_popup .cart_wrapper .totals .right .item_totals').text('£'+total_price.toFixed(2));
                $('.cart_page .cart_wrapper .totals .right .item_totals').text('£'+total_price.toFixed(2));


                //parent.slideUp();

                //window.location = window.location.href+"/#!show_cart";
            }
        });

        return false;
    });

    $("body").on("click", "#cart_popup a.remove_item", function () {
        var url = $(this).attr('href');

        $.ajax({
            url: url,
            method: "post"
        }).done(function(){

            refreshCart();

        });

        return false;

    });

    $("body").on("click", "header .cart_header .close_popup", function () {

        $(this).closest('.cart_header').removeClass('open');

        return false;

    });

    $("body").on("click", ".cart_header .account_popup .actions a.tab_link", function () {
        var tab = $(this).data("tab");

        $("header .cart_header .account_popup .tab").removeClass("active");
        $("header .cart_header .account_popup .tab."+tab).addClass("active");

        return false;

    });


    $("body").on("click", "a.open_cart_action", function () {

        $("body").addClass('cart_open');

        return false;

    });

    $('#cart_popup').on('click', function(e) {
        if (e.target !== this)
            return;

        $("body").removeClass('cart_open');
    });

    $("body").on("click", "#cart_popup a.close_cart, #cart_popup .continue_shopping_action", function () {

        $("body").removeClass('cart_open');

        return false;

    });

    $("body").on("click", "header .container nav ul li a, #navigation nav li a", function(){

        var nav = $(this).data("nav");

        if (typeof nav !== typeof undefined && nav !== false) {


            $("html, body").animate({
                scrollTop: ($("#"+nav).offset().top - $("header").height())
            }, 1000);


            $("header .container nav ul li").removeClass("open").removeClass("active");
            $(this).closest("li").addClass("active");

            $("#page").removeClass("menu");

            return false;

        }

    });

    $("body").on("click", ".navlink", function(e){
        var href = $(this).attr("href");

        if(href && !$("body").hasClass("loading") && !$("body").hasClass("in")){

            $("#pageoverlay").css({"opacity": "1"});
            $("body").addClass("loading");

            loadContent(href);

            // HISTORY.PUSHSTATE
            history.pushState('', 'New URL: '+href, href);
            e.preventDefault();

        }

        return false;

    });

    $("body").on("click", ".bar_page .see_more ", function(e){

        $("html, body").animate({
            scrollTop: ($(".bar_page .actions").offset().top - $("header").height())
        }, 1000);

        return false;

    });

    $("body").on("click", ".bar_page .book_spot", function(e){

        $("html, body").animate({
            scrollTop: ($(".bar_page .booking_embed").offset().top - $("header").height())
        }, 1000);

        return false;

    });


    /*
    $(document).on("mouseenter", "#hero a.buy_beers_action", function(e) {
        $("#hero").addClass("video_in");
    });

    $(document).on("mouseleave", "#hero a.buy_beers_action", function(e) {
        $("#hero").removeClass("video_in");
    });
     */

    $("body").on("click", ".founders .details .info .video_wrapper a.watch_action, .founders .details .info .video_wrapper .image a", function () {

        $(".founders .details .info .video_wrapper").addClass("video_in");

        loadFoundersVideo();

        return false;

    });

    $("body").on("click", ".product_card .product_quick_buy", function () {

        if(!$(this).hasClass("link")) {

            var collection = $(this).data("collection");
            var handle = $(this).data("handle");
            var url = "/products/"+handle+".js";

            $.getJSON(url, function(product) {
                var initial_product_price = (product.price / 100);

                $('#quick_buy_popup .variant_selector').empty();
                $('#quick_buy_popup .cart_errors').remove();
                $('#quick_buy_popup .image .inner').removeAttr('style');

                //
                $('#quick_buy_popup h3.product_title').text(product.title);


                $('#quick_buy_popup .buy_wrapper button.add_to_cart_action span.total_selected_price').text('£'+initial_product_price.toFixed(2));

                //
                $('#quick_buy_popup .buy_wrapper button.add_to_cart_action input[name="variant_id"]').val(product.variants[0].id);
                $('#quick_buy_popup .buy_wrapper button.add_to_cart_action input[name="variant_price"]').val((product.variants[0].price / 100));

                var loop_count = 0;


                if(product.variants.length > 1) {


                    loop_count = 2;

                    $('#quick_buy_popup .variant_selector').append('<select name="variant_selector" class="custom_select"></select>');

                    for(var x = 0; x < product.variants.length; x++) {
                        var product_price = (product.variants[x].price);
                        var price = product_price;

                        $("#quick_buy_popup .variant_selector select").append("<option value='"+product.variants[x].id+"' data-available='"+product.variants[x].available+"' data-price='"+price+"'>"+product.variants[x].title+"</option>");

                    }

                    if(collection == 'beer') {
                        $('#quick_buy_popup .image .inner').css({'background-image': 'url('+product.featured_image+')'});
                    }
                    else {
                        $('#quick_buy_popup .image .inner').css({
                            'background-image': 'url('+product.featured_image+')',
                            'background-size': '100%'
                        });
                    }

                }
                else {

                    if(collection == 'beer') {
                        $('#quick_buy_popup .image .inner').css({'background-image': 'url('+product.featured_image+')'});
                    }
                    else {
                        $('#quick_buy_popup .image .inner').css({
                            'background-image': 'url('+product.featured_image+')',
                            'background-size': '100%'
                        });
                    }

                }

                Actions.custom_dropdowns();


                $("#page").addClass('quick_buy_in');



            });

            return false;

        }

    });


    $("body").on("click", "#quick_buy_popup a.close_quick_buy", function () {

        $("#page").removeClass('quick_buy_in');

        return false;

    });

    $("body").on("click", ".buy_wrapper .quantity_selector .quantity_button.minus", function () {
        var wrapper = $(this).closest('.buy_wrapper');
        var price = wrapper.find('input[name="variant_price"]').val();
        var current_quantity = parseInt($(this).siblings("span.quantity_value").text());
        var new_quantity = (current_quantity - 1);

        if(new_quantity >= 1) {

            price = (price) * new_quantity;
            wrapper.find('span.total_selected_price').text("£"+price.toFixed(2));

            $(this).siblings("span.quantity_value").text(new_quantity);

        }
        else {
            $(this).siblings("span.quantity_value").text(1);


        }

        $('.cart_errors').remove();

        return false

    });

    $("body").on("click", ".buy_wrapper .quantity_selector .quantity_button.plus", function () {
        var wrapper = $(this).closest('.buy_wrapper');
        var price = wrapper.find('input[name="variant_price"]').val();
        var current_quantity = parseInt($(this).siblings("span.quantity_value").text());
        var new_quantity = (current_quantity + 1);

        if(new_quantity > 1) {

            price = (price) * new_quantity;

            wrapper.find('span.total_selected_price').text("£"+price.toFixed(2));

            $(this).siblings("span.quantity_value").text(new_quantity);

        }
        else {
            $(this).siblings("span.quantity_value").text(1);


        }

        $('.cart_errors').remove();

        return false

    });

    $("body").on("click", "button.add_to_cart_action", function () {
        //var id = $(this).data("variant");
        var id = $(this).find('input[name="variant_id"]').val();
        var quantity = $(this).siblings('.quantity_selector').find('span.quantity_value').text();

        if(id && quantity) {
            var data = {
                "id": id,
                "quantity": quantity
            };

            $(this).addClass('disabled').attr('disabled', 'disabled');

            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                context: this,
                success: function() {

                    //window.location = window.location.href+"/#!show_cart";

                    $(this).removeClass('disabled').removeAttr('disabled');

                    refreshCart();

                },
                error: function (data) {
                    console.log(data);

                    var response_text = JSON.parse(data.responseText);

                    $('<div class="cart_errors">'+response_text.description+'</div>').insertBefore($(this));

                }
            });

        }

        return false;

    });


    //form, remove default value on click
    $(".form input[type=text], .form input[type=email], .form textarea").each(function(){

        $(this).data("value", $(this).val());

        if($(this).val().length > 0){

            $(this).closest("li").addClass("focused");

        }

        $(this).focus(function(){

            $(this).closest("li").addClass("focused");

            if ($(this).val() == $(this).data("value")) {
                $(this).val("");
            }

        });

        $(this).blur(function(){

            if ($(this).val().length == 0){
                $(this).val($(this).data("value"));

                $(this).closest("li").removeClass("focused");
                $(this).parent().removeClass("complete");

            }
            else{

                $(this).parent().addClass("complete");
                $(this).closest("li").removeClass("error");
                $(this).closest("li").find(".message").remove();

            }

        });

    });

    /********************************************************************************************** defaults */

    /* window resize */
    $(window).resize(function(e) {

        main();

    });

    var lastScrollTop = 0;
    $(window).scroll(function(event){
        var st = $(this).scrollTop();
        var sHeight = $(window).height();

        //console.log(st);

        if($('.product_page').length) {

            if($(window).width() > 720) {

                if (!$('.product_page').hasClass('alternative')) {
                    var next = $(".product_page .product_images .product_image.featured_product").next();

                    //

                    if (st + ($('.product_page .product_details_wrapper .details').height() - (sHeight / 2 + 150)) > $('.bottom_anchor').offset().top - 0) {

                        var diff = ((st / 4) * -1);
                        var top = (st + ($('.product_page .product_details_wrapper .details').height() - (sHeight / 2 + 150)) - $('.bottom_anchor').offset().top - 0) * -1;

                        $('.product_page .product_details_wrapper .details').css({top: (diff + top)});

                    } else {

                        $(".product_page .product_details_wrapper .details").css({"top": "-" + (st / 4) + "px"});
                    }

                    if ( st >= (next.offset().top - sHeight)) {
                        var top = (st - (next.offset().top - sHeight)) * -1;
                        next.addClass('in');

                        $(".product_page .product_images .product_image.first").css({top: top});
                        $(".product_page .product_images .product_image.featured_product").css({top: top});

                    }
                    else {
                        $(".product_page .product_images .product_image.first").css({top: 0});
                        $(".product_page .product_images .product_image.featured_product").css({top: 0});

                        $(".product_page .product_images .product_image.first .background").css({"background-position": "0 -" + (st / 8) + "px"});

                    }

                }

            }

        }

        if($('.images_slider').length) {

            if ( st >= $(".images_slider .images").offset().top - (sHeight / 2) ) {
                $(".images_slider .images").addClass('in');
            }

        }

        if($('.collage').length) {

            if ( st >= $(".collage .images").offset().top - (sHeight / 2) ) {
                $(".collage .images").addClass('in');
            }

        }


        if(st > 250){

            if(!$("header").hasClass("out")) {

                $("header").addClass("out");


                setTimeout(function () {

                    if ($(this).scrollTop() > 250) {
                        $("header").addClass("outtop");
                    }

                }, 1000);

            }

        }
        else {

            if(!$("header").hasClass("in")){
                $("header").removeClass("out").removeClass("outtop");
            }

            $("header").removeClass("in").removeClass("out").removeClass("outtop");

        }

        if (st > lastScrollTop){
            // downscroll code
            $("header").removeClass("in");

        } else {

            $("header").addClass("in");
        }
        lastScrollTop = st;

        $("#hero").css({"background-position": "0 " + (st / 6) + "px"});

        $('.shop_page .list img.stamp').css({"transform":"translate(0, "+(st/4)+"px)"});
        $('.page_wrapper .top .title').css({"transform":"translate(0, "+(st/8)+"px)"});

    });

    // THIS EVENT MAKES SURE THAT THE BACK/FORWARD BUTTONS WORK AS WELL
    window.onpopstate = function(event) {

        if(!$("body").hasClass("loading")){

            $("#pageoverlay").css({"opacity": "1"});
            $("body").addClass("loading");

            loadContent(location.pathname);

        }
        else{

            window.history.pushState(null, "", window.location.href);

        }

    };

    /*
     * Main function. runs on init() and window.resize
     *
     */
    function main() {
        var sHeight = $(window).height();
        var sWidth = $(window).width();

        beer_slider();

    }

    /*
     * Main initialize function. runs on document.ready
     *
     */
    function init() {
        var verify = sessionStorage.getItem('wp_verify');

        if(verify) {

            window.scroll(0, 0);

            $("#agegate").addClass('hide');

        }
        else {

            $("#agegate").addClass('ready');

        }


        main();

        checkCart();

        Actions.custom_dropdowns();

        loadHeroVideo();

        AOS.init({
            once: true
        });

        $(".bars_page .bar_list .list .bar").flip({
            trigger: "manual"
        });

        $(document).on("click", ".bars_page .bar_list .list .bar .front .inner a.book_now", function() {

            $(this).closest(".bar").addClass("active").flip(true);

            return false;

        });

        $(document).on("click", ".bars_page .bar_list .list .bar .back a.close", function() {

            $(this).closest(".bar").removeClass("active").flip(false);

            return false;

        });


        if($(window).width() > 1200){

            skr = skrollr.init(
                {
                    forceHeight: false
                }
            );

        }
        else {

            $("body").removeAttr("style");

        }

        var param = window.location.hash.substr(1);
        if(param && param == '!show_cart') {

            $("body").addClass('cart_open');

        }

        product_image_slider();
        product_merch_slider();
        bar_images_slider();

    }

    /**
     * Home hero video autoplay function
     */
    function loadHeroVideo() {

        if ($("#hero .video_wrapper").length) {
            var video = document.getElementById('homevideo');
            var source = document.createElement('source');

            source.setAttribute('src', $('#hero-video-url').val());
            source.setAttribute('type', 'video/mp4');

            video.appendChild(source);
            video.play();
        }

    }

    function loadFoundersVideo() {

        if ($(".founders .details .info .video_wrapper").length) {
            var video = document.getElementById('foundersvideo');
            var source = document.createElement('source');

            source.setAttribute('src', $('#founders-video-url').val());
            source.setAttribute('type', 'video/mp4');

            video.appendChild(source);
            video.play();

            $('video').on('ended',function(){
                $(".founders .details .info .video_wrapper").removeClass("video_in");
            });

        }

    }

    /**
     * Updated cart meta data
     */
    function checkCart() {


        jQuery.getJSON('/cart.js', function(cart) {

            console.log(cart);

            if(cart && cart.item_count > 0) {
                var item_count = cart.item_count;

                $(".cart_header").find(".item_count").text(item_count);
                $("#cart_popup .top h3 span.item_count").text('('+item_count+')');

            }

        });

    }

    /**
     * Refresh cart data
     */
    function refreshCart() {

        $.ajax({
            url: "/cart",
            method: "get"
        }).done(function(data){
            var cart = $('<div />').append(data).find('#cart');

            //$("#cart_popup .cart_wrapper").empty().append(cart);
            $("#cart_popup .wrapper .inner .cart_wrapper").remove().append(cart);
            $("#cart_popup .wrapper .inner").append(cart);

            $("#page").removeClass('quick_buy_in');

            checkCart();

            $("body").addClass('cart_open');

        });

    }

    /**
     * Ajax page loading
     *
     * @param url
     */
    function loadContent(url){
        var sWidth = $(window).width();

        if(url){
            $.ajax({
                url: url,
                method: "get"
            }).done(function(data){

                var page = $(data).filter("#page").html();
                var title = $(data).filter("title").text();

                $("title").text(title);

                setTimeout(function(){
                    $("body").addClass("in");

                    $("#page").empty().append(page).removeClass("menu");
                    $("#page").removeClass('beer_nav_in');

                    $("body").removeClass('loaded');
                    $("#page").removeClass('load');

                    if(sWidth > 1200) {
                        //Refresh skrollr
                        skr.refresh();
                    }
                    else {

                        $("body").removeAttr("style");
            
                    }

                    beer_slider();
                    Actions.custom_dropdowns();
                    product_image_slider();
                    product_merch_slider();
                    bar_images_slider();


                    $("header").removeClass("in").removeClass("out").removeClass("outtop");

                    $("html, body").animate({
                        scrollTop: ($("#page").offset().top)
                    }, 10, "linear");
                    
                    setTimeout(function () {

                        $("#pageoverlay").css({"opacity": "0"});
                        $("body").removeClass("loading").removeClass("in").addClass('loaded');

                        $("body").removeAttr("style");
                        $("html").removeAttr("style");

                        checkCart();
                        loadHeroVideo();

                        AOS.init({
                            once: true
                        });

                        $(".bars_page .bar_list .list .bar").flip({
                            trigger: "manual"
                        });

                    }, 1200);

                }, 850);

            });

        }

    }//loadContent

    /**
     * Home page beers horizontal scroller
     */
    function beer_slider(){

        if($('#beer_slide')[0] && $(window).width() > 768){

            if(typeof $('#beer_slide').offset().top != 'undefined'){

                var sWidth = $(window).width();
                var sHeight = $(window).outerHeight() - 60;
                var difference = Math.abs(sWidth - sHeight);

                $('#beer_slide .track .item .wrap').css({"height": sHeight + "px"});

                w = 0;

                $.each($('#beer_slide .track .item'), function(index, item) {
                    w += $(this).width();
                });

                $('#beer_slide').css({"height": (w - difference + 250)+"px"});

                $(window).scroll(function(e){

                    if($('#beer_slide')[0]){
                        if(typeof $('#beer_slide').offset().top != 'undefined'){

                            safteyTop = $('#beer_slide').offset().top;
                            safetyBottom = safteyTop + $('#beer_slide').outerHeight();
                            scroll = $(document).scrollTop() + 60;
                            scrolledLeft = scroll - safteyTop;

                            if(scroll > safteyTop && scroll < safetyBottom - sHeight){

                                if(!$('#beer_slide .inner').hasClass('fixed')){
                                    $('#beer_slide .inner').addClass('fixed');
                                }

                                $('#beer_slide .progress-wrap .bar').css({"width": ((scroll - safteyTop) / (safetyBottom - safteyTop - sHeight) * 100) + "%"});

                                if($('#beer_slide .inner').hasClass('absolute')){
                                    $('#beer_slide .inner').removeClass('absolute');
                                }

                                if($('#beer_slide .inner').hasClass('relative')){
                                    $('#beer_slide .inner').removeClass('relative');
                                }

                            }else if(scroll > safetyBottom - sHeight){

                                if($('#beer_slide .inner').hasClass('fixed')){
                                    $('#beer_slide .inner').removeClass('fixed');
                                }

                                if(!$('#beer_slide .inner').hasClass('absolute')){
                                    $('#beer_slide .inner').addClass('absolute');
                                }

                                if($('#beer_slide .inner').hasClass('relative')){
                                    $('#beer_slide .inner').removeClass('relative');
                                }

                            }else if(scroll < safteyTop){

                                if(!$('#beer_slide .inner').hasClass('relative')){
                                    $('#beer_slide .inner').addClass('relative');
                                }

                                if($('#beer_slide .inner').hasClass('absolute')){
                                    $('#beer_slide .inner').removeClass('absolute');
                                }

                                if($('#beer_slide .inner').hasClass('fixed')){
                                    $('#beer_slide .inner').removeClass('fixed');
                                }

                            }
                            
                            /***** set scroll opsition */
                            if($('#beer_slide .inner .progress-wrap').css("display") != "none"){
                                $('#beer_slide .track').scrollLeft(scrolledLeft);
                            }else{
                                $('#beer_slide .track').scrollLeft(0);
                            }

                        }
                    }

                });

            }

        }
        else {

            $('#beer_slide .inner .track .item.first').remove();
            $('#beer_slide .inner .track .item.last').remove();

            $('#beer_slide .inner .track').slick({
                dots: false,
                arrows: false,
                infinite: false,
                mobileFirst: true,
                autoplay: true,
                autoplaySpeed: 3000,
                centerMode: true,
                responsive: [
                    {
                        breakpoint: 2000,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 1600,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 1024,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });

        }

    }//beer_slider

    function product_merch_slider() {

        $('.merch_list .list').slick({
            dots: false,
            arrows: false,
            infinite: true,
            mobileFirst: true,
            autoplay: true,
            autoplaySpeed: 3000,
            centerMode: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 2000,
                    settings: "unslick"
                },
                {
                    breakpoint: 1600,
                    settings: "unslick"
                },
                {
                    breakpoint: 1024,
                    settings: "unslick"
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

    }

    function product_image_slider() {

        $('.product_images_slider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            mobileFirst: true,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 2000,
                    settings: "unslick"
                },
                {
                    breakpoint: 1600,
                    settings: "unslick"
                },
                {
                    breakpoint: 1024,
                    settings: "unslick"
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        if($(window).width() <= 768) {

            if($('.product_page .product_images .product_image.featured_product'.length)) {
                $('.product_images_slider').slick('slickRemove',1);
            }

        }

    }

    function bar_images_slider() {

        $('.bar_images_slider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000
        });

    }

});

$(window).load(function(){

    //add the loader class
    $("#page").addClass("load");
    $("#pageoverlay").addClass("load");

    setTimeout(function () {
        $("#preloader").addClass("loaded");
    }, 500);

});

var Actions = (function () {

    //setup custom dropdowns
    var custom_dropdowns = function(){

        if ($(".custom_select").length > 0){
            var max_characters = 25;//max character length on the dropdown

            $(".custom_select").each(function (index, el) {
                var $select = (!$(this).hasClass("gfield")) ? $(el) : $(this).find("select"); //check if gravity forms
                var $wrapper = $("<div class='selectWrap' />");
                var $fake_select = $("<div class='fakeSelect'></div>");
                var $fake_dropdown = $("<div class='dropdown'></div>");

                var selected_text = $select.find("option:selected").text();

                var name = ($(this).attr("name")) ? $(this).attr("name") : "";

                $select.wrap($wrapper);
                $select.after($fake_dropdown);
                $select.after($fake_select);

                // set selected value as default
                if($select.val() !== "" && $select.val() !== "0"){
                    $fake_select.addClass("selected").html(selected_text);
                }
                else{

                    if(!selected_text) {
                        selected_text = $select.find("option").text();
                    }

                    $fake_select.html(selected_text);

                }
                //.css({"width":$select.width()}); //Auto size

                /*
                 * Loop through select options.
                 * Limit the length
                 *
                 */
                $select.find("option").each(function(index){
                    var text = $(this).text();
                    var classes = (text.length > max_characters) ? "long" : "";
                    var price = $(this).data("price");
                    var available = $(this).data("available");

                    //Duplicate each option to the fake dropdown menu
                    $fake_dropdown.append("<span data-id='"+$(this).val()+"' data-available='"+available+"' data-price='"+(price / 100)+"' class='"+classes+"'>"+$(this).text()+"<span class='icon'></span></span>");

                });

                // change handler
                $select.change(function (){

                    //set the selected options
                    $fake_select.html($(this).find("option:selected").text());
                    $fake_select.append("<span></span>");
                    $fake_select.addClass("selected");

                    $(this).closest(".field").removeClass("error");

                });

                //add a class on focus
                $select.focus(function (){
                    $fake_select.addClass("focus");
                }).focusout(function (){
                    $fake_select.removeClass("focus");
                });

                //dropdown icon
                $fake_select.append("<span></span>");
            });

        }

        jQuery(document).off("click", ".fakeSelect");
        jQuery(document).off("click", ".dropdown span");

        //
        jQuery(document).on("click", ".fakeSelect", function(){
            $(".selectWrap").removeClass("open");

            $(this).parent().toggleClass("open");

        });

        //set value when dropdown selected
        jQuery(document).on("click", ".dropdown span", function(){
            var value = $(this).text(),
                classes = (value.length > max_characters) ? "long" : "",
                id = $(this).data("id"),
                parent = $(this).closest(".dropdown"), //dropdown
                selectWrap = parent.closest(".selectWrap");

            var price = $(this).data("price");
            var available = $(this).data("available");

            $(".dropdown span").removeClass("active");
            $(this).addClass("active");


            //set the fake value
            parent.siblings(".fakeSelect").addClass(classes).empty().html(value);
            parent.siblings(".fakeSelect").append("<span></span>");

            //set the real value to select box
            parent.siblings("select").val(id);

            //set the wrapper to open (for dropdown to open)
            selectWrap.removeClass("open");


            $(".buy_wrapper .quantity_selector span.quantity_value").text("1");

            if(available == true) {
                $("button.add_to_cart_action").addClass("active").find('span.button_text').text("Order");
                $(".buy_wrapper button.add_to_cart_action span.total_selected_price").text("£"+price.toFixed(2));
            }
            else {
                $("button.add_to_cart_action").removeClass("active").find('span.button_text').text("Out Of Stock");
                $(".buy_wrapper button.add_to_cart_action span.total_selected_price").text("");
            }

            $("button.add_to_cart_action input[name='variant_id']").val(id);
            $("button.add_to_cart_action input[name='variant_price']").val(price);

        });

    };

    return {
        custom_dropdowns : custom_dropdowns

    }

})();